module.exports = __webpack_public_path__ + "img/unchecked.478a382.svg";